<script>
  import Router from 'svelte-spa-router';
  import routes from '$/client/routes.js';
  import Reloader from "$/client/components/Reloader.svelte";
  import Bandolier from '$/admin/bando/Bandolier.svelte';
</script>

<Router {routes}/>

{#if process.env.DANGER_ADMIN === "1"}
  <Reloader />
  <Bandolier shown={ false }/>
{/if}
